import React, { createContext, useContext } from "react";
import { useQuery, gql } from "@apollo/client";
import { ProgressSpinner } from "primereact/progressspinner";
import { AuthContext } from "./AuthContext";

const DataContext = createContext();

const GET_ALL_DATA = gql`
  query GetAllData {
    playerPropsMLB: playerProps(league: "MLB") {
      name
      prop
      overUnder
    }
    playerPropsNBA: playerProps(league: "NBA") {
      name
      prop
      overUnder
    }
    playerPropsNFL: playerProps(league: "NFL") {
      name
      prop
      overUnder
    }
    baseballMatchupStats: baseballMatchupStats {
      matchupStat
      name
      pos
      team
      home
      time
      opp
      pitcher
      ab
      h
      xbh
      hr    
      rbi
      bb
      k
      avg
      obp
      slg
      ops
    }
    pointsPerGame: scrapeDataByConfig(configName: "Opponent Points per game") {
      team
      home
      away
      year
      __typename
    }
    hitsPerGame: scrapeDataByConfig(configName: "Team hits per game") {
      team
      home
      away
      year
    }
    strikeoutsPerGame: scrapeDataByConfig(
      configName: "Team strikeouts per game"
    ) {
      team
      home
      away
      year
    }
    reboundsPerGame: scrapeDataByConfig(
      configName: "Opponent Rebounds per game"
    ) {
      team
      home
      away
      year
    }
    assistsPerGame: scrapeDataByConfig(configName: "Opponent Assist per game") {
      team
      home
      away
      year
    }
    iningsRuns: scrapeDataByConfig(configName: "1st Inning Runs") {
      team
      home
      away
      year
    }
    passYardsAllowed: scrapeDataByConfig(configName: "Pass Yards Allowed") {
      team
      home
      away
      year
    }
    playerStats: playerStats {
      Category
      PlayerName
      Prizepicks
      Draftkings
      OverUnder
    }
    hotStreaksMLB: hotStreaks(configName: "Hot Streaks MLB") {
      lastUpdated
      Player
      odd
      Streak
      Prop
    }
    hotStreaksNBA: hotStreaks(configName: "Hot Streaks NBA") {
      lastUpdated
      Player
      odd
      Streak
      Prop
    }
    hotStreaksNFL: hotStreaks(configName: "Hot Streaks NFL") {
      lastUpdated
      Player
      odd
      Streak
      Prop
    }
    rushingYardsAllowed: scrapeDataByConfig(configName: "Rushing Yards Allowed") {
      team
      home
      away
      year
    }
  }
`;

const DataProvider = ({ children }) => {
  const { isSubscribed, isLoading: authLoading } = useContext(AuthContext);
  const { loading, error, data } = useQuery(GET_ALL_DATA, {
    fetchPolicy: 'network-only',
    skip: authLoading || !isSubscribed,
  });

  const contextValue = isSubscribed ? (data ? { ...data } : {}) : {};

  if (authLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
      </div>
    );
  }

  if (isSubscribed && loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
      </div>
    );
  }

  if (isSubscribed && error) {
    console.error("GraphQL Error:", error);
    return <p>Error loading data from graphql. Please try again.</p>;
  }

  return (
    <DataContext.Provider value={contextValue}>
      {children}
    </DataContext.Provider>
  );
};

export { DataContext, DataProvider };
